/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ChangeRequestApprovedMailRequest = {
    changeRequestType?: ChangeRequestApprovedMailRequest.changeRequestType;
    approvedIds?: Array<number>;
};
export namespace ChangeRequestApprovedMailRequest {
    export enum changeRequestType {
        COMPETITOR = 'COMPETITOR',
        FRESHNESS = 'FRESHNESS',
        INSTRUCTION = 'INSTRUCTION',
        FLYER = 'FLYER',
    }
}

